module.exports = __webpack_public_path__ + "static/img/big-3.b1f4720.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/big-3.png
// module id = KVRx
// module chunks = 1